import { ContainerRowCentre, LinkDiv } from "./Containers";

const Footer = () => {
  const currentYear = (new Date()).getFullYear();

  return (
      <div style={{
        backgroundColor: 'rgb(240, 240, 240)',
        paddingTop: '8px',
        flex: '1'
        }}>
        <ContainerRowCentre>
          The world's worst search engine
        </ContainerRowCentre>
        <ContainerRowCentre>
          <LinkDiv>
            <a href="http://yourapp.ie">
              © 2023-{currentYear} YourApp.ie. All rights reserved.
            </a>
          </LinkDiv>
        </ContainerRowCentre>
      </div>
  );
}

export default Footer;